import type { ProxyItem } from '../types';

export const eligibleTransferTargets = (proxies: ProxyItem[], sourceProxyID: number): ProxyItem[] =>
  proxies.filter((proxy) => proxy.status === 'active' && proxy.proxy_id !== sourceProxyID);

export const remainingTransferSeconds = (expireAt: string, now = new Date()): number => {
  const expireMs = new Date(expireAt).getTime();
  if (!Number.isFinite(expireMs)) return 0;
  return Math.max(0, Math.floor((expireMs - now.getTime()) / 1000));
};
